module.exports = __webpack_public_path__ + "img/germany-diseases-of-the-nervous-system-male.4ac6a229.png";